import { MenuAim } from '../lib/es6-menu-aim.js';
import Affix from '../lib/affix.js';

export default {
	init: function() {
		document.querySelectorAll('.language-switcher > a').forEach((ele) => {
			ele.addEventListener('click', e => {
				e.preventDefault();
				e.currentTarget.parentNode.classList.toggle('open');
			});
		});

		document.querySelectorAll('#nav__trigger, #menu__close').forEach((ele) => {
			ele.addEventListener('click', e => {
				e.preventDefault();
				document.querySelector('#menu').classList.toggle('open');
			});
		});

		let menuEle, config;

		menuEle = document.getElementById('menu-parent');
		config = {
			activate: function(row) {
				let dropdown = row.querySelector('.dropdown');

				row.classList.add('dropdown--open');

				if(dropdown !== null) {
					dropdown.style.left = (row.offsetWidth - 10) + 'px';
				}
			},
			deactivate: function(row) {
				row.classList.remove('dropdown--open');
			},
			rowSelector: '.menu-item--depth-0',
			openClassName: 'dropdown--open',
			activationDelay: 1000,
			tolerance: 1000,
			submenuSelector: '.dropdown'
		};
		console.log(window.outerWidth);
		this.affix = new Affix('#header__nav', document.querySelector('main'));

		if(window.outerWidth > 991){
			this.menuAim = new MenuAim(menuEle, config);
		} else {
			this.mobileNav();
		}
	},
	mobileNav: function(){
		if(document.querySelector('.menu-item--depth-0 > a') !== null) {
			document.querySelectorAll('.menu-item--depth-0 > a').forEach(el => {
				el.addEventListener('click', evt => {
					if(evt.target.nextElementSibling !== null){
						evt.preventDefault();
						evt.target.closest('.nav').querySelectorAll('.menu-item--depth-0').forEach(el => el.classList.remove('dropdown--open'));
						evt.target.closest('.menu-item--depth-0').classList.toggle('dropdown--open');
					}
				});
			});
		}
	}
}

